const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const intFormatter = new Intl.NumberFormat("en-US");

export function formatUsd(n: number): string {
  return usdFormatter.format(n);
}

export function formatInt(n: number): string {
  return intFormatter.format(n);
}
